import React, { useState, useEffect, useCallback } from 'react';
import {
  Form,
  InputNumber,
  Button,
  Card,
  Row,
  Col,
  Typography,
  App,
  Spin,
} from 'antd';
import { getFollowUpTargetExpired, updateFollowUpTargetExpired } from '../../../services/settingsService';
import { FollowUpTargetExpired } from '../../../types/followup';
import { useAuth } from '../../../contexts/AuthContext';

const { Title } = Typography;

const JadwalManagement: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const { message } = App.useApp();
  const { hasPermission } = useAuth();

  const canUpdate = hasPermission('leadJadwalFU.update');

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getFollowUpTargetExpired();
      if (response.data && response.data.status === 'success') {
        form.setFieldsValue(response.data.data);
      } else {
        message.error('Gagal memuat data jadwal');
      }
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || 'Gagal mengambil data jadwal';
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  }, [form, message]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleSave = async (values: FollowUpTargetExpired) => {
    setLoading(true);
    try {
      await updateFollowUpTargetExpired(values);
      message.success('Jadwal berhasil diperbarui');
      fetchData();
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || 'Gagal menyimpan data jadwal';
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
        <Col>
          <Title level={2} style={{ margin: 0 }}>
            Manajemen Jadwal Follow Up
          </Title>
        </Col>
      </Row>

      <Card bordered={false}>
        <Spin spinning={loading}>
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSave}
            name="jadwalManagementForm"
            initialValues={{
                deadline_follow_up_1: 0,
                deadline_follow_up_2: 0,
                deadline_follow_up_3: 0,
                deadline_closing: 0,
            }}
          >
            <Form.Item
              name="deadline_follow_up_1"
              label="Tenggat Waktu Follow Up 1 (Hari setelah status New)"
              rules={[{ required: true, message: 'Field ini tidak boleh kosong!' }]}
            >
              <InputNumber min={0} style={{ width: '100%' }} addonAfter="Hari" disabled={!canUpdate} />
            </Form.Item>

            <Form.Item
              name="deadline_follow_up_2"
              label="Tenggat Waktu Follow Up 2 (Hari setelah Follow Up 1)"
              rules={[{ required: true, message: 'Field ini tidak boleh kosong!' }]}
            >
              <InputNumber min={0} style={{ width: '100%' }} addonAfter="Hari" disabled={!canUpdate} />
            </Form.Item>

            <Form.Item
              name="deadline_follow_up_3"
              label="Tenggat Waktu Follow Up 3 (Hari setelah Follow Up 2)"
              rules={[{ required: true, message: 'Field ini tidak boleh kosong!' }]}
            >
              <InputNumber min={0} style={{ width: '100%' }} addonAfter="Hari" disabled={!canUpdate} />
            </Form.Item>

            <Form.Item
              name="deadline_closing"
              label="Tenggat Waktu Closing (Hari setelah Follow Up 3)"
              rules={[{ required: true, message: 'Field ini tidak boleh kosong!' }]}
            >
              <InputNumber min={0} style={{ width: '100%' }} addonAfter="Hari" disabled={!canUpdate} />
            </Form.Item>

            {canUpdate && (
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>
                  Simpan
                </Button>
              </Form.Item>
            )}
          </Form>
        </Spin>
      </Card>
    </div>
  );
};

export default JadwalManagement;
